import { FC } from "react";
import { Helmet } from "react-helmet";
import { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import "./img/traxi_login.css";
import Button from "@mui/material/Button";
import usePageLogin from "./usePageLogin";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import OtpInput from "./components/OtpInput";
import CountdownTimer from "./components/Timer";

export interface PageLoginProps {
  className?: string;
  onCloseModalQuickView?: any;
}

const PageLogin: FC<PageLoginProps> = ({
  className = "",
  onCloseModalQuickView,
}) => {
  const { loading, isOTPVerified, error } = useSelector(
    (state: any) => state.authFetchOTPSliceReducer
  );

  const {
    number,
    handleGetProfile,
    handleOtpChange,
    handleOTP,
    handlePhone,
    err,
  } = usePageLogin(onCloseModalQuickView);

  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>AgrotracDigital:Login/Register</title>
      </Helmet>
      <h2 className="text-center font-medium text-[18px]">Login/Register</h2>
      <div className="container-fluid p-4 shadow-lg">
        <div className="max-w-sm mx-auto">
          {/* FORM */}
          <form
            className="grid grid-cols-1 py-4 pt-0"
            autoComplete="off"
            method="POST"
          >
            <small>
              {
                <div className="bg-red-400  text-white  text-xs rounded-sm">
                  {err || error}
                </div>
              }
            </small>
            {!isOTPVerified && (
              <PhoneInput
                international={false}
                defaultCountry="IN"
                autoComplete="off"
                placeholder="Enter mobile number"
                className="border-none w-full rounded-lg bg-primary-200 px-5 mb-2 text-xs"
                value={number}
                onChange={(e) => handlePhone(e)}
                rules={{ required: true }}
                maxLength="11"
                id="PageLoginPhone"
                pattern="[0-9]{10}"
                error={
                  number
                    ? isValidPhoneNumber(number)
                      ? undefined
                      : "Invalid phone number"
                    : "Phone number required"
                }
              />
            )}
            {isOTPVerified ? (
              <div>
                <label className="block">
                  <span className="flex justify-between items-center font-semibold text-sm text-neutral-600">
                    Enter OTP
                  </span>
                  <OtpInput onOtpChange={handleOtpChange} />
                </label>
                <div className="countdown-text flex justify-around mt-2 py-2">
                  <CountdownTimer onResendOtp={handleOTP} />
                </div>
                <Button
                  variant="contained"
                  type="submit"
                  className="w-full rounded-lg bg-primary-300 py-2 px-1 font-semibold mt-4"
                  onClick={(e) => handleGetProfile(e)}
                  sx={{ height: "40px", marginTop: "10px" }}
                  disabled={false}
                >
                  {loading ? (
                    <CircularProgress sx={{ color: "#fff" }} size={20} />
                  ) : (
                    "Continue"
                  )}
                </Button>
              </div>
            ) : (
              <div>
                <Button
                  variant="contained"
                  type="submit"
                  className="w-full"
                  sx={{ marginTop: "10px", height: "40px" }}
                  onClick={(e) => handleOTP(e)}
                >
                  {loading ? (
                    <CircularProgress sx={{ color: "#fff" }} size={20} />
                  ) : (
                    "SEND OTP"
                  )}
                </Button>
                <div className="mt-3">
                  <label htmlFor="" className="">
                    <a
                      href="/privacy-policy"
                      target="_blank"
                      style={{ fontSize: ".6rem", color: "rgb(122, 120, 120)" }}
                    >
                      By continuing I agree with the{" "}
                      <label className="underline underline-offset-2">
                        Privacy Policy
                      </label>
                      ,{" "}
                      <label className="underline underline-offset-2">
                        Terms & Conditions
                      </label>
                    </a>
                  </label>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default PageLogin;
